import axios from "axios";

export const taxesService = {
  getActiveTax,
};

function getActiveTax() {
  return axios
    .get(`/taxes/active`)
    .then((res) => res.data?.payload?.content ?? null)
    .catch((err) => Promise.reject(err));
}